import React from 'react';

interface Section {
  name: string;
  id: string;
}

interface TableOfContentsProps {
  sections: Section[];
}

const TableOfContents: React.FC<TableOfContentsProps> = ({ sections }) => (
  <div className="bg-gray-100 p-3 rounded-lg shadow-md w-full mb-4">
    <h2 className="text-base md:text-xl font-semibold mb-2 mt-1">
      Table of Contents
    </h2>
    <div className="md:grid md:grid-cols-2 gap-2">
      {/* For mobile: Show all items in one list */}
      <ol className="list-none pl-5 md:hidden">
        {sections.map((section, index) => (
          <li key={index} className="mb-1 text-sm md:text-md">
            <div className="flex items-center">
              <span className="mr-2">{index + 1}.</span>
              <a
                href={`#${section.id}`}
                className="text-blue-600 hover:underline"
              >
                {section.name}
              </a>
            </div>
          </li>
        ))}
      </ol>

      {/* For larger screens: Divide the list in two */}
      <div className="hidden md:block">
        <ol className="list-none pl-5">
          {sections
            .slice(0, Math.ceil(sections.length / 2))
            .map((section, index) => (
              <li key={index} className="mb-1 text-sm md:text-md">
                <div className="flex items-center">
                  <span className="mr-2">{index + 1}.</span>
                  <a
                    href={`#${section.id}`}
                    className="text-blue-600 hover:underline"
                  >
                    {section.name}
                  </a>
                </div>
              </li>
            ))}
        </ol>
      </div>
      <div className="hidden md:block">
        <ol
          className="list-none pl-5"
          start={Math.ceil(sections.length / 2) + 1}
        >
          {sections
            .slice(Math.ceil(sections.length / 2))
            .map((section, index) => (
              <li key={index} className="mb-1 text-sm md:text-md">
                <div className="flex items-center">
                  <span className="mr-2">
                    {Math.ceil(sections.length / 2) + index + 1}.
                  </span>
                  <a
                    href={`#${section.id}`}
                    className="text-blue-600 hover:underline"
                  >
                    {section.name}
                  </a>
                </div>
              </li>
            ))}
        </ol>
      </div>
    </div>
  </div>
);

export default TableOfContents;
